import { connect } from 'react-redux';
import { get } from 'lodash';
import TotalCostAmount from '../../components/total-cost-amount';
import { CLAIM_NAMESPACE } from '../../actions';

const mapStateToProps = ({ purchases, projections }, ownProps) => {
  const purchase = purchases.byId[purchases.current];
  const projected = get(projections, `${CLAIM_NAMESPACE}.purchase`);
  const { costType } = purchase.product;
  const { costRange } = projected || purchase;

  return {
    constraints: ownProps.constraints,
    currentCostRange: costRange,
    costType,
    namespace: CLAIM_NAMESPACE,
  };
};

export default connect(mapStateToProps)(TotalCostAmount);



// WEBPACK FOOTER //
// ./src/desktop/containers/purchase-claim/total-cost-range.container.js